import { ApiLink } from './api-link.model';
import { LanguageCode } from './language.model';
import { Revision } from './revision.model';
import { UUID } from './uuid.model';
import { CreditRedemptionState } from './credit-redemption.model';

export interface Industry {
  id: UUID;
  name: { [code in LanguageCode]: string };
}

export interface IndustryExtras extends Revision {
  _state: Readonly<CreditRedemptionState>;
  _links: {
    self: ApiLink<'GET'>;
  };
  _type: 'industry';
}

export type IndustryDto = Industry & IndustryExtras;
export type IndustryViewModel = Industry;

export const isIndustryDto = (value: unknown): value is IndustryDto =>
  (value as IndustryDto)?._type === 'industry';
